import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL || '';

export const buildQrUrl = (qrToken) => `${PUBLIC_BASE_URL}/public/qr/${qrToken}`;

export const QRThumbnail = ({ qrToken, size = 32 }) => {
  if (!qrToken) return <div className="bg-slate-100 rounded" style={{ width: size, height: size }} />;
  return <QRCodeSVG value={buildQrUrl(qrToken)} size={size} level="L" />;
};
